import { random } from 'lodash';
import { z } from 'zod';
import { Messages } from '../constants';

export const legalClientAccountingSchema = z.object({
  Bank: z.string().optional().default(''),
  IBAN: z.string().min(1, { message: Messages.Required }),
  BIC: z.string().optional().default(''),
  idAccounting: z.number(),
});

export type ILegalClientAccounting = z.infer<
  typeof legalClientAccountingSchema
>;

export const initBankInformation = (): ILegalClientAccounting => ({
  idAccounting: -random(1, Number.MAX_SAFE_INTEGER),
  Bank: '',
  IBAN: '',
  BIC: '',
});
